<template>
  <div class="changjing-column">
    <el-page-header @back="$router.push('/changjing')" content="栏目列表"></el-page-header>
    <c-tag-level type="changjing"></c-tag-level>
  </div>
</template>

<script>
import CTagLevel from '@/components/common/tag'

export default {
  name: 'changjing-column',
  components: { CTagLevel },
  data() {
    return {
    }
  }
}
</script>

<style lang="scss">
.changjing-column{
  background:#fff;
}
</style>
